import React from "react";
import { TableContainer, Table } from "@mui/material";
import { ListHead } from "../list";
import TableContent from "../TableContent.component";
import WarningListRow from "./WarningListRow.component";
import { fieldsSorter } from "core/utils";

const WarningListTable = (props) => {
  const {
    data,
    onClickMutate = () => { },
    isVisitor,
    onClickStation = () => { },
  } = props;

  return (
    <TableContainer>
      <Table>
        <ListHead {...props} />

        <TableContent
          {...props}
          data={data?.sort(fieldsSorter(["stationId", "-severity"]))}
        >
          {(item, index) => (
            <WarningListRow
              key={`${item?.stationId}${index}`}
              item={{
                ...item,
              }}
              onClickStation={() => onClickStation(item?.stationId)}
              isVisitor={isVisitor}
              onClickMutate={() => onClickMutate(item?.alertId)}
            />
          )}
        </TableContent>
      </Table>
    </TableContainer>
  );
};

export default WarningListTable;
